export function equalityArray(array1: any[], array2: any[]) {
  // check the length
  if (array1.length != array2.length) {
    return false;
  } else {
    let result = false;

    // comparing each element of array
    for (let i = 0; i < array1.length; i++) {
      result = array2.findIndex((val) => val === array1[i]) >= 0;
    }
    return result;
  }
}
